<template>
    <div class="body d-flex py-lg-3 py-md-2">
      <div class="container-xxl">
        <!-- Existing Content -->
        <div class="row clearfix">
          <div class="col-md-12">
            <div class="card border-0 mb-2 no-bg">
              
            </div>
          </div>
        </div>
    
        <!-- daysoff Table -->
        <div class="row clearfix g-3">
          <div class="col-sm-12">
            <div class="mb-3 d-flex justify-content-end">
  <button type="button" class="btn btn-success me-2" @click="bulkAcceptDayOffs">Accept Selected</button>
  <button type="button" class="btn btn-danger me-2" @click="bulkRejectDayOffs">Reject Selected</button>
  <button type="button"  style="color:var(--secondary-color);" class="btn" data-bs-toggle="modal" data-bs-target="#addDayOffModal">
    <i class="icofont-plus me-2 fs-6"></i> Days Off
  </button>
</div>
            <div class="card mb-3">
              <div class="card-body table-responsive" style="width: 95%; margin: 0 auto">
                
                <table id="myProjectTable" class="table table-hover align-middle mb-0 mis_table" style="width: 100%">
                  <thead>
                    <tr>
                      <th style="width:3%;" v-if="superUser">
  <input type="checkbox" @change="toggleSelectAll($event)" v-model="selectAll" />
</th>

                      <th style="width:6%;" v-if="superUser">
                      <div  class="d-flex align-items-center">
                        <select class="ms-1 nav-link rounded" name="" id="dropdownManagers"
                          @change="updateManagerFilter">
                          <option value="" selected>User</option>
                          <option v-for="manager in managers" :key="manager.id"
                              :value="manager.id">
                              {{ manager.username }}
                          </option>
                        </select>
                        <img class="menu-img" src="../assets/images/icons8-superman.svg"
                                                        alt="Citrine Logo" style="width:2em" >
                      </div>
                      
                    </th>
                      <th style="width:10%;"><div>Start<i class="fa fa-sort sorting-icon" @click.prevent="sortBy('from')"></i></div></th>
                      <th style="width:10%;"><div>End<i class="fa fa-sort sorting-icon" @click.prevent="sortBy('to')"></i></div></th>
                      <th style="width:12%;"><div>Days</div></th>
                       <th style="width:12%;"><div>Type</div></th>

                      <th style="width:12%;"><div>Reason</div></th>
                 <th style="width:6%; background-color:white; border:none" class=no-after><div>Actions</div></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(daysoff, index) in data" :key="daysoff.id" :class="{ 'approved': daysoff.approved === 1, 'not-approved': daysoff.approved === 0 }">
                      <td  v-if="superUser" >
  <input type="checkbox" v-model="selectedDaysOff" :value="daysoff.id" v-if="daysoff.approved === null"/>
</td>
                      <td>{{ daysoff.user?.username }}</td>
                      <td>{{ daysoff.from_formatted }}</td>
                      <td>{{ daysoff.to_formatted }}</td>
                      <td>{{ daysoff.days }}</td>
                      <td>{{ daysoff.kind?.title }}</td>
                      <td>{{ daysoff.description }}</td>
                     
                    <td>
  <template v-if="daysoff.approved === null">
    <div class="d-inline-flex">
      <button type="button" class="btn btn-secondary me-1" @click="acceptDayOff(daysoff.id)" title="Accept">
        <i class="icofont-tick-mark text-white"></i>
      </button>
      <button type="button" class="btn btn-secondary" @click="rejectDayOff(daysoff.id)" title="Reject">
        <i class="icofont-close text-white"></i>
      </button>
    </div>
  </template>
</td>

                    </tr>
                    <tr v-if="!data || !data.length">
                        <td colspan="100">No data</td>
                    </tr>
                  </tbody>
                </table>
                <nav aria-label="Page navigation" v-if="data && data.length">
                  <ul class="pagination mt-4" v-if="paginationLinks && paginationLinks.length > 0">
                    <li class="page-item" v-for="(paginationLink, index) in paginationLinks" :key="index" :class="{ active: paginationLink.active }">
                      <router-link :to="{ path: 'days-off-requests', query: { ...filters, page: getPageFromUrl(paginationLink.url) } }" v-if="paginationLink.url">
                        <span class="page-link" v-html="paginationLink.label"></span>
                      </router-link>
                      <span class="page-link" v-else v-html="paginationLink.label"></span>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
  
        <!-- Accept Day Off Modal -->
        <div class="modal fade" id="accept-daysoff-form" tabindex="-1" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title fw-bold" id="acceptdaysoffLabel">Accept PTO?</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <input name="id" id="id" type="hidden" v-model="daysoffData.id" />
                <div class="mb-3">
                  The client will have to request further changes, if needed.
                </div>
              </div>
              <div class="modal-footer">
<!--                 <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
 -->                <button type="button" class="btn btn-secondary" @click="confirmAcceptDayOff">Accept</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Reject Day Off Modal -->
        <div class="modal fade" id="reject-daysoff-form" tabindex="-1" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title fw-bold" id="acceptdaysoffLabel">Reject PTO?</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <input name="id" id="id" type="hidden" v-model="daysoffData.id" />
                <div class="mb-3">
                    The client will have to make a new request, if needed.
                </div>
              </div>
              <div class="modal-footer">
<!--                 <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
 -->                <button type="button" class="btn btn-secondary" @click="confirmRejectDayOff">Reject</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Add Days Off Modal -->
        <div class="modal fade" id="addDayOffModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
        <h5 class="modal-title fw-bold">Add Days Off  <img src="../assets/images/icons8-superman.svg"
                                                            alt="Citrine Logo" class="menu-img ms-1 managerProfIcon"
                                                            style="width:.1.5em"></h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="d-flex" style="width:30%"><input type="checkbox" @change="toggleAllUsers" v-model="allUsersSelected" class="me-2"><span style="margin-top: 1px;">Select All</span></th>
              <th>Username</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.id">
              <td><input type="checkbox" v-model="bulkDayOff.selectedUsers" :value="user.id" /></td>
              <td>{{ user.text }}</td>
            </tr>
          </tbody>
        </table>
     
      <div class="deadline-form">
                <div class="row g-3 mb-3">
                  <div class="col">
    <label for="from" class="form-label">Start Date</label>
    <input
      type="date"
      class="form-control"
      id="from"
      v-model="bulkDayOff.from"
      :min="today" 
      placeholder="Start Date"
    />
  </div>
                  <div class="col">
                    <label for="to" class="form-label">End Date</label>
                    <input type="date" class="form-control" id="to" v-model="bulkDayOff.to" placeholder="End Date" :min="bulkDayOff.from || today" >
                  </div>
                </div>
              </div>
              <div class="mb-3">
  <label for="kind_id" class="form-label">Type</label>
  <select class="form-select" id="kind_id" v-model="bulkDayOff.kind_id">
    <option :value="1">ΚΑΝΟΝΙΚΗ</option>
    <option :value="2">AΠΟΥΣΙΑ</option>
    <option :value="3">ΑΠΕΡΓΙΑ</option>
    <option :value="4">ΘΑΝΑΤΟΥ ΣΥΓΓΕΝΟΥΣ</option>
    <option :value="5">ΣΧΟΛΙΚΗ</option>
    <option :value="6">ΑΔΕΙΑ ΦΡΟΝΤΙΣΤΗ</option>
    <option :value="7">ΣΠΟΥΔΑΣΤΙΚΗ</option>
    <option :value="8">ΑΝΕΥ ΑΠΟΔΟΧΩΝ</option>
    <option :value="9">ΑΣΘΕΝΕΙΑΣ</option>
  </select>
</div>

              <div class="mb-1">
                <label for="description" class="form-label">Reason</label>
                <textarea class="form-control" id="description" rows="3" v-model="bulkDayOff.description" placeholder="Reason"></textarea>
              </div> </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="submitBulkDayOff">Submit</button>
      </div>
    </div>
  </div>
</div>


      </div>
    </div>
  </template>
  
  <script>
import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useFetchData } from '@/composables/useFetchData';
import { fetchAll, accept, reject, multaccept, multreject, createBulkDayOff  } from '@/services/daysoffrequests';
import { useToast } from 'vue-toastification';
import { mapGetters } from 'vuex';
import { fetchManagers } from '@/services/followup';
import { getClientsServicesStatusesUsers } from '@/services/projects';

const defaultdaysoffData = {
  id: '',
  user: '',
  from: '',
  to: '',
  description: ''
};

export default {
  name: 'DaysOff',
  computed: {
        ...mapGetters({
            getUserPermission: 'getUserPermission',
            getSuperUserPermission: 'getSuperUserPermission',

        }),
        superUser() {
            return this.getSuperUserPermission === 1;
        },
       
    },
  setup() {
    const route = useRoute();
    const toast = useToast();
    const managers = ref([]);
    const allData = ref({ users: [], clients: [], statuses: [], services: [] });
    const bulkDayOff = ref({
  from: '',
  to: '',
  selectedUsers: [],
});
const users = computed(() => allData.value.users);
const allUsersSelected = ref(false);

const toggleAllUsers = () => {
  if (allUsersSelected.value) {
    bulkDayOff.value.selectedUsers = users.value.map(u => u.id);
  } else {
    bulkDayOff.value.selectedUsers = [];
  }
};

const submitBulkDayOff = async () => {
  if (!bulkDayOff.value.from || !bulkDayOff.value.to || !bulkDayOff.value.description || !bulkDayOff.value.kind_id || bulkDayOff.value.selectedUsers.length === 0) {
    toast.error('Please select users, type, date range and reason.');
    return;
  }

  try {
    const res = await createBulkDayOff(bulkDayOff.value);
    if (res.data.success) {
      toast.success(res.data.message);
      $('#addDayOffModal').modal('hide');
      $('body').removeClass('modal-open');
      $('.modal-backdrop').remove();
      fetchData(); // Refresh your main table
      // Reset
      bulkDayOff.value = { from: '', to: '', selectedUsers: [] };
      allUsersSelected.value = false;
    } else {
      toast.error(res.data.message);
    }
  } catch (error) {
    toast.error('Error submitting days off.');
  }
};
    const selectedDaysOff = ref([]);
    const selectAll = ref(false);

    // Toggle all checkboxes
    const toggleSelectAll = (event) => {
  if (event.target.checked) {
    // Only select requests where 'approved' is null
    selectedRequests.value = data.value.filter((request) => request.approved === null).map((request) => request.id);
  } else {
    selectedRequests.value = [];
  }
};

    // Bulk Accept Function
    const bulkAcceptDayOffs = async () => {
      if (selectedDaysOff.value.length === 0) {
        toast.warning('No days off selected.');
        return;
      }
      try {
        const response = await multaccept({ ids: selectedDaysOff.value });
        if (response.data.success) {
          toast.success(response.data.message);
          selectedDaysOff.value = [];
          fetchData();
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error('Error processing request.');
      }
    };

    // Bulk Reject Function
    const bulkRejectDayOffs = async () => {
      if (selectedDaysOff.value.length === 0) {
        toast.warning('No days off selected.');
        return;
      }
      try {
        const response = await multreject({ ids: selectedDaysOff.value });
        if (response.data.success) {
          toast.success(response.data.message);
          selectedDaysOff.value = [];
          fetchData();
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error('Error processing request.');
      }
    };

    const { data, paginationLinks, filters, updateFilters, fetchData, sortBy } = useFetchData(fetchAll, { page: route.query.page || 1 }, { page: 1 });

    const daysoffData = ref(defaultdaysoffData);

    const fetchManagersData = async () => {
            try {
                const response = await fetchManagers();
                if (response.data.success) {
                    managers.value = response.data.data;
                }
            } catch (error) {
                console.error('Failed to fetch managers:', error);
            }
        };

        const updateManagerFilter = (event) => {
            const newManagerId = event.target.value;
            updateFilters({ ...filters.value, userFilter: newManagerId, page: 1 });
        };

    const acceptDayOff = (id) => {
      daysoffData.value.id = id;
      $('#accept-daysoff-form').modal('toggle');
    };

    const rejectDayOff = (id) => {
      daysoffData.value.id = id;
      $('#reject-daysoff-form').modal('toggle');
    };

    const confirmAcceptDayOff = async () => {
      try {
        const response = await accept(daysoffData.value);
        if (response.data.success) {
          toast.success(response.data.message);
          $('#accept-daysoff-form').modal('toggle');
          fetchData();
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error('Error submitting form');
      }
    };

    const confirmRejectDayOff = async () => {
      try {
        const response = await reject(daysoffData.value);
        if (response.data.success) {
          toast.success(response.data.message);
          $('#reject-daysoff-form').modal('toggle');
          fetchData();
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error('Error submitting form');
      }
    };

    const getPageFromUrl = (url) => {
      if (!url) return null;
      const urlObj = new URL(url, window.location.origin);
      return urlObj.searchParams.get('page');
    };

    onMounted(async () => {
      await fetchData();
      fetchManagersData();
      const tmpAllData = await getClientsServicesStatusesUsers({ params: { type: "subtasks" } });
                let newData = { users: [], statuses: [], clients: [], services: [] };

                for (let i = 0; i < tmpAllData.data.users.length; i++) {
                    newData.users.push({ id: tmpAllData.data.users[i].id, text: tmpAllData.data.users[i].username });
                }
                for (let i = 0; i < tmpAllData.data.statuses.length; i++) {
                    newData.statuses.push({ id: tmpAllData.data.statuses[i].id, text: tmpAllData.data.statuses[i].description });
                }
                for (let i = 0; i < tmpAllData.data.clients.length; i++) {
                    newData.clients.push({ id: tmpAllData.data.clients[i].id, text: tmpAllData.data.clients[i].title });
                }
                for (let i = 0; i < tmpAllData.data.services.length; i++) {
                    newData.services.push({ id: tmpAllData.data.services[i].id, text: tmpAllData.data.services[i].title });
                }

                allData.value = newData; // `allData` is a ref, so use `.value`

    });

    return {
      data,
      paginationLinks,
      filters,
      updateFilters,
      fetchData,
      daysoffData,
      getPageFromUrl,
      acceptDayOff,
      confirmAcceptDayOff,
      rejectDayOff,
      confirmRejectDayOff, sortBy,
      updateManagerFilter, managers,
      selectedDaysOff,
      selectAll,
      toggleSelectAll,
      bulkAcceptDayOffs,
      bulkRejectDayOffs,toggleAllUsers, submitBulkDayOff, bulkDayOff, users,
      allUsersSelected,
    };
  },
  metaInfo: {
    title: 'Days Off',
    meta: [
      { name: 'description', content: 'MIS - Days Off' },
      { property: 'og:title', content: 'MIS - Days Off' },
      { property: 'og:description', content: 'This is the days off page.' }
    ]
  }
};
</script>

  
  <style scoped>
  .dropdown-menu.show {
    display: block;
  }
  
  .approved{
  background-color: rgb(107, 219, 107);
}

.not-approved{
  background-color: rgb(241, 111, 111);
}
</style>

  